import { useAuthActions } from "@convex-dev/auth/react";
import { Button, Image } from "@mantine/core";

import logoUrl from "../assets/logo.png";

import { FullPageMessage } from "./FullPageMessage";

/**
 * What a signed-out visitor sees. Rendered by `main.tsx` inside `<Unauthenticated>`, outside
 * the router entirely — so this is the one screen in the app that no route owns.
 *
 * It exists as a component rather than as JSX in `main.tsx` because `useAuthActions` is a
 * hook, and `main.tsx` renders its provider tree at module scope with no component to call
 * one in.
 */
function Landing() {
  const { signIn } = useAuthActions();
  return (
    <FullPageMessage
      hero={
        <Image
          src={logoUrl}
          style={{ width: "16rem", maxWidth: "80vw" }}
          alt="Plantings Logo"
        />
      }
      title="Plantings"
      body="a plant tracker and garden journal"
      action={
        <Button
          onClick={() =>
            void signIn("google", { redirectTo: window.location.href })
          }
        >
          Sign in
        </Button>
      }
      styles={{ body: { fontStyle: "italic" } }}
    />
  );
}

export default Landing;
